import React from "react";

const ImageCard = ({ imageUrl }) => {
  return (
    <div className="rounded-md ">
      <img
        src={imageUrl}
        alt=""
        className="w-full cursor-pointer overflow-hidden rounded-md"
      />
    </div>
  );
};

export default ImageCard;
